// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__HBOg3","content":"Popup_content__ZMrcb","backdrop":"Popup_backdrop__2F6E6"};